<template>
	<!-- VApp is an element which is required to use Vuetify. See https://vuetifyjs.com/en/ for help -->
	<VApp
		v-cloak
		class="main-ctn"
	>
		<AppHeader
			v-if="!isSspa"
		/>

		<MessageBar />

		<NotificationBar />

		<VMain>
			<Breadcrumbs />
			<!-- Transition between routes -->
			<transition
				name="fade"
				mode="out-in"
			>
				<!-- Load the component defined in the router for the current route -->
				<RouterView />
			</transition>
		</VMain>

		<AppFooter v-if="!maintenance && !isSspa" />
	</VApp>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component from 'vue-class-component';

	import { Meta, MetaInfo } from '@/decorators';

	// Static import for faster rendering
	import { AppHeader, AppFooter, MessageBar, Breadcrumbs } from '@/components/layout';

	// Env var
	declare const QRP_MAINTENANCE: string;

	/** App is the main component */
	@Component({
		components: {
			AppHeader,
			AppFooter,
			MessageBar,
			Breadcrumbs
		}
	})
	export default class App extends Vue {
		isSspa = Vue.prototype.$SSPA_ENABLED;

		get maintenance(): boolean {
			return QRP_MAINTENANCE === 'true';
		}

		/** The meta informations of the route */
		/* istanbul ignore next */
		@Meta
		metaInfo(): MetaInfo {
			return {
				// If no sub-components specify a metaInfo.title, this title will be used
				title: this.$t('common.meta.title') as string,
				// All titles will be injected into this template
				titleTemplate: this.$t('common.meta.titleTemplate') as string,
				meta: [
					{
						name: 'description',
						content: this.$t('common.meta.description') as string
					}
				]
			};
		}
	}
</script>

<style lang="scss">
.vd-notification-bar.v-snack--top {
	top: unset !important;
}
</style>
